<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

This repository is private intellectual property.

<template>

    <RouterLink :to="child.path" class="sdev-nav-item" active-class="is-active">

        <span class="sdev-nav-title">
            {{ child.title }}
        </span>

        <span v-if="badgeCount" class="sdev-nav-badge">
            {{ badgeCount }}
        </span>

        <span v-if="showAudit" class="sdev-nav-audit" />

    </RouterLink>

</template>

<script setup>

import { computed } from "vue"
import { useNavigationUI } from '@/framework/bootstrap/useNavigationUI'

const props = defineProps({
    child: Object
})

const { getBadge } = useNavigationUI()

const badgeCount = computed(() => {

    return props.child?.badgeKey
        ? getBadge(props.child.badgeKey)
        : null

})

const showAudit = computed(() => {
    return Boolean(props.child?.meta?.audit?.enabled)
})

</script>